import SearchSwiper from './component'

export default SearchSwiper